<template>
  <div v-if='isLoading'>
    <v-container>
      <v-row>
        <v-col>
          <wc-loading line msg='Loading template'></wc-loading>
        </v-col>
      </v-row>
    </v-container>
  </div>
  <div v-else>
    <wc-page-title :title='title' subtitle='Snow Template'>
      <template v-slot:rightSide>
        <wc-archive-button
          @toggleArchive='toggleArchive'
          :isArchived='template.archived'
        ></wc-archive-button>
      </template>
    </wc-page-title>
    <v-container>
      <v-alert type='error' border='bottom'>This is a template, not an actual estimate!</v-alert>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <basics
            :template='template'
            @update='updateTemplate'
          ></basics>
        </v-col>
        <v-col cols='12' md='4'>
          <estimate-amount
            :estimate='template'
            @update='updateTemplate'
          ></estimate-amount>
        </v-col>
        <v-col cols='12' md='4'>
          <driveway-rating v-if='template' :estimate='template'></driveway-rating>
        </v-col>
      </v-row>
      <v-row class='mt-6 pt-6'>
        <v-col cols='12'>
          <deliverable
            :estimate='template'
            @update='updateTemplate'
            isTemplate
          ></deliverable>
        </v-col>
      </v-row>
      <v-row class='mt-6 pt-6'>
        <v-col cols='12'>
          <line-items :estimate='template'></line-items>
        </v-col>
        <v-col cols='12'>
          <line-items :estimate='template' optional></line-items>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='4' offset-md='8'>
          <totals @update='updateTemplate' :estimate='template'></totals>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import estimatesAPI from '@/modules/estimates/api/estimates'
import Deliverable from '@/modules/estimates/components/Deliverable'
import Basics from '@/modules/estimates/components/snowTemplates/Basics'
import DrivewayRating from '@/modules/estimates/components/snow/DrivewayRating'
import LineItems from '@/modules/estimates/components/LineItems'
import EstimateAmount from '@/modules/estimates/components/EstimateAmount'
import Totals from '@/modules/estimates/components/Totals'

export default {
  name: 'snow-template',
  data: () => ({
    isLoading: true,
    isSaving: true,
    template: null,
    lines: [],
    customToolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }]
    ]
  }),
  computed: {
    title () {
      if (this.template) {
        return this.template.name
      } else {
        return 'No name?'
      }
    }
  },
  created () {
    this.getTemplate()
  },
  methods: {
    async getTemplate () {
      this.isLoading = true
      this.template = await estimatesAPI.getEstimates(this.$route.params.id)
      this.isLoading = false
    },
    async toggleArchive () {
      this.template.archived = !this.template.archived
      this.template = await estimatesAPI.updateEstimate(this.template)
    },
    async updateTemplate (template) {
      this.template = await estimatesAPI.updateEstimate(template)
    }
  },
  components: {
    basics: Basics,
    deliverable: Deliverable,
    'driveway-rating': DrivewayRating,
    'line-items': LineItems,
    'estimate-amount': EstimateAmount,
    totals: Totals
  }
}
</script>
